import axiosInstance from "api/axiosInstance"
import { batch } from "react-redux"
import { providerTransferAction } from "./provider-transfer-slice"
import SAlert from "components/Alert"

export const getProviderTransferInfo = id => dispatch => {
  dispatch(
    providerTransferAction.setTransferInfo({
      loading: true,
      error: null,
      data: null,
    })
  )
  axiosInstance
    .get(`/v1/provider-transfer/info/${id}`)
    .then(response => {
      dispatch(
        providerTransferAction.setTransferInfo({
          loading: false,
          error: null,
          data: response?.data,
        })
      )
    })
    .catch(error => {
      dispatch(
        providerTransferAction.setTransferInfo({
          loading: false,
          error: error?.response?.data?.error || "Failed to load info",
          data: null,
        })
      )
      console.log(error)
    })
}

export const createProviderTransfer = (data, callback) => dispatch => {
  dispatch(providerTransferAction.setLoading(true))
  axiosInstance
    .post("/v1/provider-transfer", data)
    .then(response => {
      SAlert({
        title: "Success",
        text: "Transfer request created successfully",
      })
      batch(() => {
        dispatch(providerTransferAction.setError(null))
        dispatch(providerTransferAction.setLoading(false))
      })
      if (callback) callback(true)
    })
    .catch(error => {
      dispatch(providerTransferAction.setLoading(false))
      if (error?.response?.data?.error) {
        SAlert({
          title: "Error",
          text: error.response.data.error,
          status: "error",
        })
      } else {
        SAlert({
          title: "Error",
          text: "Failed to create transfer request",
          status: "error",
        })
      }
      if (callback) callback(false)
    })
}

export const getProviderTransfers =
  (url, pageNumber = 10) =>
  dispatch => {
    dispatch(providerTransferAction.setLoading(true))
    url = url || "/v1/provider-transfers"
    axiosInstance
      .get(url, {
        params: { pageNumber },
      })
      .then(response => {
        batch(() => {
          dispatch(providerTransferAction.setError(null))
          dispatch(providerTransferAction.setData(response.data))
          dispatch(providerTransferAction.setLoading(false))
        })
      })
      .catch(error => {
        dispatch(providerTransferAction.setLoading(false))
        console.log(error)
      })
  }

export const getAdminProviderTransfers =
  (pageNumber = 10, status = null) =>
  dispatch => {
    dispatch(providerTransferAction.setLoading(true))
    axiosInstance
      .get("/v1/admin/provider-transfers", {
        params: { pageNumber, status },
      })
      .then(response => {
        batch(() => {
          dispatch(providerTransferAction.setError(null))
          dispatch(providerTransferAction.setData(response.data))
          dispatch(providerTransferAction.setLoading(false))
        })
      })
      .catch(error => {
        dispatch(providerTransferAction.setLoading(false))
        console.log(error)
      })
  }

export const approveProviderTransfers = (ids, adminNote, callback) => dispatch => {
  dispatch(providerTransferAction.setLoading(true))
  axiosInstance
    .post("/v1/provider-transfers/approve", { ids, admin_note: adminNote })
    .then(response => {
      SAlert({ title: "Success", text: "Transfers approved successfully" })
      dispatch(getAdminProviderTransfers())
      batch(() => {
        dispatch(providerTransferAction.setError(null))
        dispatch(providerTransferAction.setLoading(false))
      })
      if (callback) callback(true)
    })
    .catch(error => {
      dispatch(providerTransferAction.setLoading(false))
      if (error?.response?.data?.error) {
        SAlert({
          title: "Error",
          text: error.response.data.error,
          status: "error",
        })
      } else {
        SAlert({
          title: "Error",
          text: "Failed to approve transfers",
          status: "error",
        })
      }
      if (callback) callback(false)
    })
}

export const rejectProviderTransfers = (ids, adminNote, callback) => dispatch => {
  dispatch(providerTransferAction.setLoading(true))
  axiosInstance
    .post("/v1/provider-transfers/reject", { ids, admin_note: adminNote })
    .then(response => {
      SAlert({ title: "Success", text: "Transfers rejected successfully" })
      dispatch(getAdminProviderTransfers())
      batch(() => {
        dispatch(providerTransferAction.setError(null))
        dispatch(providerTransferAction.setLoading(false))
      })
      if (callback) callback(true)
    })
    .catch(error => {
      dispatch(providerTransferAction.setLoading(false))
      if (error?.response?.data?.error) {
        SAlert({
          title: "Error",
          text: error.response.data.error,
          status: "error",
        })
      } else {
        SAlert({
          title: "Error",
          text: "Failed to reject transfers",
          status: "error",
        })
      }
      if (callback) callback(false)
    })
}
